import React from "react";
import { Stack } from "@mui/material";

import { FooterOne } from "./FooterOne";
import { FooterTwo } from "./FooterTwo";
import { FooterThree } from "./FooterThree";

export const DesktopFooter = ({ translate }) => {
  return (
    <Stack spacing={3} direction="row" justifyContent="space-around" p={4}>
      <Stack direction="column" flex={1}></Stack>
      <Stack direction="column" flex={2} p={2}>
        <FooterOne translate={translate} />
      </Stack>
      <Stack direction="column" flex={2} p={2}>
        <FooterTwo translate={translate} />
      </Stack>
      <Stack direction="column" width="40%" p={2}>
        <FooterThree translate={translate} />
      </Stack>
    </Stack>
  );
};
